module.exports = __webpack_public_path__ + "img/1.c7a90e11.png";